<template>
    <div>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-dark">
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="pl-0">
                            <h4 class="display-3 text-white">Our Leaders</h4>
                            <p class="text-white">Our church is blessed with faithful pastors who lead us with
                                willingness, eagerness, and humility. Take a moment to get to know our current <b>OBCM
                                    Sta. Ana</b> pastors and their key areas of service.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped section-lg my-0">
            <div class="container">
                <div class="row justify-content-center mb-4">

                    <!-- Ptr. Uziel Idurot -->
                    <div class="col-lg-6">
                        <card class="border-0 mt-2" body-classes="py-4" id="ptr-uziel">
                            <div class="row">
                                <div class="col-lg-6">
                                    <img v-lazy="'img/pastors/ptr-uziel.png'" class="img-fluid rounded shadow">
                                    <h6 class="text-dark text-uppercase mt-4">Ptr. Uziel Idurot</h6>
                                    <p class="small">Lead Pastor</p>
                                </div>
                                <div class="col-lg-12">
                                    <p>
                                        As the lead pastor of OBCM Sta. Ana, he focuses primarily on shepherding and oversees the teaching direction of the church. He also provides pastoral mentoring for the churches of OBCM Association.
                                    </p>
                                    <b-button v-b-toggle.collapse-1 variant="outline-primary" size="sm">See
                                        More</b-button>
                                    <b-collapse id="collapse-1" class="mt-2">
                                        <b-card>
                                            <p class="description">
                                                <b>Ministry Involvement</b>
                                            <ul>
                                                <li><b>2006 to 2015:</b> Youth Leader at One Body Christian Ministries
                                                    (OBCM),
                                                    Sta. Ana
                                                </li>
                                                <li><b>2006 to 2015:</b> Director of Conforming to Christ (C2C) Ministry
                                                </li>
                                                <li><b>2014 to 2021:</b> School Administrator and Spiritual Adviser at
                                                    Metropolitan
                                                    Academy of Manila (MAM)</li>
                                                <li><b>2014 to Present:</b> Worker at iDisciple Philippines</li>
                                                <li><b>2015:</b> Ordained Pastor at One Body Christian Ministries
                                                    (OBCM), Sta
                                                    Ana</li>
                                                <li><b>2016 to 2018:</b> Youth Coordinator at Luzon Convention of
                                                    Southern
                                                    Baptist
                                                    Churches (LCSBC)</li>
                                                <li><b>2016 to Present:</b> Facilitator at Philippine Baptist
                                                    Theological
                                                    Seminary (PBTS) Seminary Education by Extension (SEE)</li>
                                                <li><b>2016 to Present:</b> Lead Pastor at One Body Christian Ministries
                                                    (OBCM),
                                                    Sta. Ana</li>
                                                <li><b>2016 to 2020:</b> OBCM Association Vice Chairman</li>
                                                <li><b>2021 to Present:</b> iDisciple Philippines Officer</li>
                                            </ul>
                                            </p>
                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>
                        </card>
                    </div>

                    <!-- Ptr. Lyndon Nabua -->
                    <div class="col-lg-6">
                        <card class="border-0 mt-2" body-classes="py-4" id="ptr-lyndon">
                            <div class="row">
                                <div class="col-lg-6">
                                    <img v-lazy="'img/pastors/ptr-lyndon.png'" class="img-fluid rounded shadow">
                                    <h6 class="text-dark text-uppercase mt-4">Ptr. Lyndon Nabua</h6>
                                    <p class="small">Pastor</p>
                                </div>
                                <div class="col-lg-12">
                                    <p>
                                        He is currently ministering as one of the associate pastors at OBCM Sta Ana. He is the main advisor for the legal affairs of the church.
                                    </p>
                                    <b-button v-b-toggle.collapse-2 variant="outline-primary" size="sm">See
                                        More</b-button>
                                    <b-collapse id="collapse-2" class="mt-2">
                                        <b-card>
                                            <p class="description">
                                                <b>Ministry Involvement</b>
                                            <ul>
                                                <li><b>2005 to 2015:</b> Lay Preacher at One Body Christian Ministries
                                                    (OBCM),
                                                    Sta. Ana
                                                </li>
                                                <li><b>2006 to 2021:</b> Board-of-Trustees Chairman of Metropolitan
                                                    Academy of
                                                    Manila (MAM)</li>
                                                <li><b>2006 to 2026:</b> Board-of-Trustees Chairman of One Body
                                                    Christian
                                                    Ministries (OBCM)</li>
                                                <li><b>2015:</b> Ordained Pastor at One Body Christian Ministries
                                                    (OBCM), Sta
                                                    Ana </li>
                                                <li><b>2015 to Present:</b> Associate Pastor in One Body Christian
                                                    Ministries
                                                    (OBCM),
                                                    Sta. Ana</li>
                                                <li><b>2014 to 2024:</b> OBCM Association Chairman</li>
                                            </ul>
                                            </p>
                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>
                        </card>
                    </div>

                    <!-- Ptr. Joel Idurot -->
                    <div class="col-lg-6">
                        <card class="border-0 mt-2" body-classes="py-4" id="ptr-joel">
                            <div class="row">
                                <div class="col-lg-6">
                                    <img v-lazy="'img/pastors/ptr-joel.png'" class="img-fluid rounded shadow">
                                    <h6 class="text-dark text-uppercase mt-4">Ptr. Joel Idurot</h6>
                                    <p class="small">Pastor Emeritus</p>
                                </div>
                                <div class="col-lg-12">
                                    <p>
                                        As one of the elders of OBCM Sta. Ana,
                                        he is
                                        currently focused on the church planting initiatives of OBCM Association. He is
                                        the current moderator of Viscaya-Ifugao Churches Association
                                        (VIZBACA). On top of that, he serves as the interim pastor of Temple Baptist
                                        Church, Aritao, Nueva Vizcaya.
                                    </p>

                                    <b-button v-b-toggle.collapse-3 variant="outline-primary" size="sm">See
                                        More</b-button>
                                    <b-collapse id="collapse-3" class="mt-2">
                                        <b-card>
                                            <p class="description">
                                                <b>Ministry Involvement</b>
                                            <ul>
                                                <li><b>1977 to 1980:</b> Youth President, Olivet Baptist Church
                                                </li>
                                                <li><b>1977 to 1985:</b> Bible Study Leader, Olivet Baptist Church</li>
                                                <li><b>1985:</b> Ordained Pastor at Olivet Baptist Church (later renamed
                                                    Metro Manila Baptist Church (MMBC), then renamed as One Body
                                                    Christian Ministries (OBCM))</li>
                                                <li><b>1991 to 2016:</b> Lead Pastor, One Body Christian Ministries
                                                    (OBCM), Sta
                                                    Ana</li>
                                                <li><b>1991 to 2016:</b> Moderator for OBCM Association</li>
                                                <li><b>1991 to Present:</b> Church Planter for OBCM Association</li>
                                                <li><b>1992 to 1995:</b> Luzon Convention of Southern Baptist Churches (LCSBC) Mission and Evangelism Committee</li>
                                                <li><b>1996 to 2002:</b> Philippine Baptist S.B.C. (PBSBC) Board Member (Two-term)</li>
                                                <li><b>1996 to 2016:</b> School Director of Metropolitan Academy Manila (MAM) (for 20 years)</li>
                                                <li><b>2004 to 2007:</b> Philippine Baptist Theological Seminary Board Vice Chairman</li>
                                                <li><b>2005 to Present:</b> Facilitator at Philippine Baptist Theological Seminary (PBTS), Seminary Education by Extension (SEE)</li>
                                                <li><b>2016 to Present:</b> Pastor Emeritus at One Body Christian Ministries (OBCM), Sta. Ana</li>
                                                <li><b>2022 to 2023:</b> Luzon Convention of Southern Baptist Churches (LCSBC) Vice Chairman</li>
                                                <li><b>2023:</b> Luzon Convention of Southern Baptist Churches (LCSBC) Project Management</li>
                                            </ul>
                                            </p>
                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>
                        </card>
                    </div>

                    <!-- Ptr. Roel Rumawak -->
                    <div class="col-lg-6">
                        <card class="border-0 mt-2" body-classes="py-4" id="ptr-roel">
                            <div class="row">
                                <div class="col-lg-6">
                                    <img v-lazy="'img/pastors/ptr-roel.png'" class="img-fluid rounded shadow">
                                    <h6 class="text-dark text-uppercase mt-4">Ptr. Roel Rumawak</h6>
                                    <p class="small">Pastor</p>
                                </div>
                                <div class="col-lg-12">
                                    <p>
                                        He presently serves as an associate pastor at OBCM Sta. Ana. He manages several
                                        of the church's key ministries, including an
                                        online bible study for children, sports fest, and mission support for
                                        churches within OBCM Association.
                                    </p>

                                    <b-button v-b-toggle.collapse-4 variant="outline-primary" size="sm">See
                                        More</b-button>
                                    <b-collapse id="collapse-4" class="mt-2">
                                        <b-card>
                                            <p class="description">
                                                <b>Ministry Involvement</b>
                                            <ul>
                                                <li><b>2009 to 2021:</b> Bible Teacher at Children Ministry of One Body
                                                    Christian Ministries (OBCM), Sta. Ana and Devotional Teacher of
                                                    Christian
                                                    Values at Metropolitan Academy of Manila (MAM) School</li>
                                                <li><b>2021:</b> Ordained Pastor at One Body Christian Ministries
                                                    (OBCM), Sta
                                                    Ana</li>
                                                <li><b>2021 to Present:</b> Associate Pastor in One Body Christian
                                                    Ministries
                                                    (OBCM), Sta. Ana </li>
                                                <li><b>2024 to Present:</b> OBCM Association Vice Chairman</li>
                                            </ul>
                                            </p>
                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>
                        </card>
                    </div>

                    <!-- Ptr. Arvick -->
                    <div class="col-lg-6">
                        <card class="border-0 mt-2" body-classes="py-4" id="ptr-arvick">
                            <div class="row">
                                <div class="col-lg-6">
                                    <img v-lazy="'img/pastors/ptr-arvick.png'" class="img-fluid rounded shadow">
                                    <h6 class="text-dark text-uppercase mt-4">Ptr. Arvick Mirondo</h6>
                                    <p class="small">Pastor</p>
                                </div>
                                <div class="col-lg-12">
                                    <p>
                                        He is currently ministering as an associate pastor at OBCM Sta
                                        Ana while serving as the overseer of the church planting
                                        initiatives at OBCM San Pedro, Laguna.
                                    </p>
                                    <b-button v-b-toggle.collapse-5 variant="outline-primary" size="sm">See
                                        More</b-button>
                                    <b-collapse id="collapse-5" class="mt-2">
                                        <b-card>
                                            <p class="description">
                                                <b>Ministry Involvement</b>
                                            <ul>
                                                <li><b>2013 to 2019:</b> Volunteer, Facilitator, and Speaker at True
                                                    Love Waits
                                                    Philippines</li>
                                                <li><b>2015 to 2018:</b> Bible Teacher at Amazing Grace Christian
                                                    Ministries
                                                    (AGCM), Southville 3A, San Pedro
                                                </li>
                                                <li><b>2022:</b> Planted a church, Grace and Truth Reformed Church
                                                    (GTRC), at
                                                    San Pedro for 6 months and served as one of the elders of the church
                                                </li>
                                                <li><b>2022 to 2025:</b> Elder-in-Training in One Body Christian
                                                    Ministries
                                                    (OBCM), Sta. Ana</li>
                                                <li><b>2025:</b> Ordained Pastor at One Body Christian Ministries
                                                    (OBCM), Sta
                                                    Ana </li>
                                                <li><b>2025 to Present:</b> Associate Pastor in One Body Christian
                                                    Ministries
                                                    (OBCM), Sta. Ana</li>
                                            </ul>
                                            </p>
                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>
                        </card>
                    </div>

                    <!-- Ptr. RM Rodriguez -->
                    <div class="col-lg-6">
                        <card class="border-0 mt-2" body-classes="py-4" id="ptr-rm">
                            <div class="row">
                                <div class="col-lg-6">
                                    <img v-lazy="'img/pastors/ptr-rm.png'" class="img-fluid rounded shadow">
                                    <h6 class="text-dark text-uppercase mt-4">Ptr. RM Rodriguez</h6>
                                    <p class="small">Pastor</p>
                                </div>
                                <div class="col-lg-12">
                                    <p>
                                        As one of the associate pastors, he is the current Board-of-Trustees Chairman of OBCM Sta. Ana. 
                                        He also oversees the music ministry of the church while actively writes and composes music for <a href="https://1worshipph.org/#/">1WorshipPH</a>, a
                                        ministry that produces gospel-centered worship songs for Filipino local
                                        churches.
                                    </p>

                                    <b-button v-b-toggle.collapse-6 variant="outline-primary" size="sm">See
                                        More</b-button>
                                    <b-collapse id="collapse-6" class="mt-2">
                                        <b-card>
                                            <p class="description">
                                                <b>Ministry Involvement</b>
                                            <ul>
                                                <li><b>2011 to 2019:</b> Volunteer, Facilitator, and Speaker at True
                                                    Love Waits
                                                    Philippines</li>
                                                <li><b>2016 to Present:</b> Volunteer at iDisciple Philippines</li>
                                                <li><b>2016 to 2022:</b> Youth Leader at Infinite Gospel Resound Church
                                                    (IGRC)
                                                </li>
                                                <li><b>2017 to Present:</b> Founder of <a href="https://1worshipph.org/#/">1WorshipPH</a>, a ministry that
                                                    produces
                                                    Gospel-Centered Filipino worship songs for Filipino local churches
                                                </li>
                                                <li><b>2022:</b> Planted a church, Grace and Truth Reformed Church
                                                    (GTRC), at
                                                    San Pedro for 6 months and served as one of the elders of the church
                                                </li>
                                                <li><b>2022 to 2025:</b> Elder-in-Training in One Body Christian
                                                    Ministries
                                                    (OBCM), Sta. Ana</li>
                                                <li><b>2022 to Present:</b> Children's Ministry Outreach Coordinator at
                                                    OBCM Pagsanjan, Laguna</li>
                                                <li><b>2025:</b> Ordained Pastor at One Body Christian Ministries
                                                    (OBCM), Sta
                                                    Ana </li>
                                                <li><b>2025 to Present:</b> Associate Pastor in One Body Christian
                                                    Ministries
                                                    (OBCM), Sta. Ana</li>
                                                <li><b>2026 to Present:</b> Board-of-Trustees Chairman of One Body Christian Ministries (OBCM)</li>
                                            </ul>
                                            </p>
                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "our-leaders",
    components: {}
};
</script>

<style scoped></style>
